import './styles/ZoomImg.scss';
import { System_DeviceOrientationMap } from '../assets/keyMap';
import { isPlatform } from '@ionic/react';
import { useContext, useState, useRef, useEffect } from 'react';
import { DebugLogger as dlog } from './Logger';

//muis
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

interface Props {
    src: string, imgRef?: any, deviceOrientation?: number
}

const nonstate = {
    pinchZoomSensitivity: 3, //higher this number less sensitive, 1 will be the max sensitivity
    maxZoom: 4, //x3,
    orientationMap: {
        LANDSCAPE: 0,
        PORTRAIT: 1
    }
}

const ZoomImg: React.FC<Props> = ({ src, imgRef, deviceOrientation }) => {
    //states
    const [imgZoom, SetImgZoom] = useState(1); // 0- 100
    const [orientation, SetOrientation] = useState(nonstate.orientationMap.LANDSCAPE); //0 - landscape, 1 - portraint

    //image zoomref
    const pinchStartRef = useRef({ x: 0, y: 0, distance: 0 } as any); //{x: 0, y: 0}
    const imgZoomRef = useRef(1);

    //watchers
    // useEffect(() => {
    //     dlog('ZoomImgTest: ' + deviceOrientation);
    // }, [deviceOrientation]);

    //event listeners functions

    //exe functions
    const GetDistance = (event: React.TouchEvent<HTMLImageElement>) => {
        return Math.hypot(event.touches[0].pageX - event.touches[1].pageX, event.touches[0].pageY - event.touches[1].pageY);
    };

    //ui functions
    const OnImgTouches = (event: React.TouchEvent<HTMLImageElement>) => {
        if (isPlatform('hybrid')) {
            if (event.touches.length >= 2) {
                event.preventDefault(); // Prevent page scroll

                // Calculate where the fingers have started on the X and Y axis
                if (pinchStartRef.current != undefined) {
                    pinchStartRef.current.x = (event.touches[0].pageX + event.touches[1].pageX) / 2;
                    pinchStartRef.current.y = (event.touches[0].pageY + event.touches[1].pageY) / 2;
                    pinchStartRef.current.distance = GetDistance(event);
                }
            }
        }
    }
    const OnImgWheel = (e: React.WheelEvent) => {
        // if (isPlatform('mobileweb')) {
        //     let currentScale = imgZoomRef.current / 100;
        //     if (e.deltaY < 0) {
        //         currentScale += .5;
        //     }
        //     else if (e.deltaY > 0) {
        //         currentScale -= .5;
        //     }

        //     let newZoom = 1 + (imgZoomRef.current * currentScale);
        //     if (newZoom <= 1)
        //         newZoom = 1;
        //     else if (newZoom >= nonstate.maxZoom)
        //         newZoom = nonstate.maxZoom;

        //     imgZoomRef.current = newZoom;
        //     SetImgZoom(imgZoomRef.current);
        // }
        if (isPlatform('mobileweb')) {
            if (e.deltaY < 0) {
                ZoomIn();
            }
            else if (e.deltaY > 0) {
                ZoomOut();
            }
        }
    }
    const OnImgTouchMoved = (event: React.TouchEvent<HTMLImageElement>) => {
        if (event.touches.length >= 2) {
            event.preventDefault(); // Prevent page scroll

            const deltaDistance = GetDistance(event);
            const scale = 1 + (deltaDistance / pinchStartRef.current.distance - 1) / nonstate.pinchZoomSensitivity;
            let newZoom = imgZoom * scale;
            if (newZoom <= 1)
                newZoom = 1;
            else if (newZoom >= nonstate.maxZoom)
                newZoom = nonstate.maxZoom;
            SetImgZoom(newZoom);
        }
    };
    const OnZoomInBtnClicked = () => {
        ZoomIn();
    };
    const OnZoomOutBtnClicked = () => {
        ZoomOut();
    };

    //exe functions
    const ZoomIn = () => {
        let currentZoom = imgZoomRef.current; // 1 - 2
        currentZoom += 0.1;

        if (currentZoom > 2)
            currentZoom = 2;

        imgZoomRef.current = currentZoom;
        SetImgZoom(imgZoomRef.current);
    }
    const ZoomOut = () => {
        let currentZoom = imgZoomRef.current; // 1 - 2
        currentZoom -= 0.1;

        if (currentZoom < 1)
            currentZoom = 1;

        imgZoomRef.current = currentZoom;
        SetImgZoom(imgZoomRef.current);
    }

    return (
        <div className={'ZoomImg ' + (deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ? 'landscape' : 'portrait')} style={
            orientation == nonstate.orientationMap.LANDSCAPE ?
                { justifyContent: 'flex-start', alignItems: 'center' }
                :
                (
                    orientation == nonstate.orientationMap.PORTRAIT ?
                        { justifyContent: 'center', alignItems: 'flex-start' }
                        :
                        {}
                )
        }>
            <img ref={imgRef != undefined ? imgRef : null} className='ZoomImg-img' src={src} style={
                orientation == nonstate.orientationMap.LANDSCAPE ?
                    { width: (100 * imgZoom).toString() + '%' }
                    :
                    (
                        orientation == nonstate.orientationMap.PORTRAIT ?
                            { height: (100 * imgZoom).toString() + '%' }
                            :
                            {}
                    )
            }
                onTouchStart={(e: React.TouchEvent<HTMLImageElement>) => OnImgTouches(e)} onTouchMove={(e: React.TouchEvent<HTMLImageElement>) => OnImgTouchMoved(e)}
                onWheel={(e: React.WheelEvent) => OnImgWheel(e)}
                onLoad={(e: any) => {
                    const { naturalWidth, naturalHeight } = e.target;
                    if (naturalHeight > naturalWidth)
                        SetOrientation(nonstate.orientationMap.PORTRAIT);
                    else
                        SetOrientation(nonstate.orientationMap.LANDSCAPE);
                }}
            />
            {
                deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ?
                    <div className='ZoomImg-option-panel'>
                        <button className='ZoomImg-option-btn' onClick={() => OnZoomInBtnClicked()}><AddIcon /></button>
                        <button className='ZoomImg-option-btn' onClick={() => OnZoomOutBtnClicked()}><RemoveIcon /></button>
                    </div>
                    :
                    null
            }
        </div>
    );
}
export default ZoomImg;